import React, { Component } from 'react';

class Popup extends Component {
  constructor() {
    super();
  }

  render() {
    const {
      children,
      className,
      idPopUpPaxSelector,
      position,
      popupType,
    } = this.props;

    return (
      <div id={ idPopUpPaxSelector } className={ `Popup ${popupType} Popup--${position} ${className}`}
        onClick={ this.onClickHandler }
        ref={ (ref) => this.popupInnerNode = ref }>
        { children }
      </div>
    );
  }

  onClickHandler = (e) => {
    e.stopPropagation(); // detiene la propagacion al padre
    e.nativeEvent.stopImmediatePropagation(); // detiene la propagacion al document
  };
}

export default Popup;
